<template>
    <div class="login-container" >
        <el-dropdown>
          <span class="el-dropdown-link">
            {{currentLangs && currentLangs.description}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in langList"
              :key="item.code"
              v-show="item.code !== currentLangs.code"
              @click.native="e => menuClick(item)"
            >{{item.description}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-input
          size="small"
          class="user-input base-input"
          v-model="form.username"
          style="width: auto"
          :placeholder="data && data.Page_index_header_form_username_placeholder"/>
        <el-input
         size="small"
         type="password"
         name="password_self"
         class="password-input base-input"
         v-model="form.password"
         style="width: auto"
         :placeholder="data && data.Page_index_header_form_password_placeholder" />
        <span  @click="login"><base-button>{{ data && data.Page_index_header_form_submit_buttonText}}</base-button></span>
        <div class="others"><base-link @click="$router.push({ path: '/register-reset', query: { type: 0 }})">{{data && data.Page_index_register_text}}</base-link> /
        <base-link @click="$router.push({ path: '/register-reset', query: {
          type: 1
        }})">{{data && data.Page_index_forget_text}}</base-link></div> 
      
    </div>
   
    
</template>

<script>
import api from '@/api/index'
import { mapState } from 'vuex'
import { loginUrl, isPrd, isPrdSite } from '@/config/url'
export default {
  name: 'Login',
  components: {},
  mixins: [],
  data() {
    return {
      loginUrl,
      form: {
        username: '',
        password: ''
      },
      langMap: new Map()
    }
  },
  computed: mapState({
    data: state =>
      state.i18n.get(state.currentLangs.code),
    langList: 'langList',
    currentLangs: 'currentLangs'
  }),
  created() {
    this.$store.dispatch('getLanguages')
    this.$store.dispatch('getDefaultLangs')
  },
  watch: {},
  mounted() {},
  methods: {
     menuClick(e) {
       this.$store.dispatch('getI18n', e)
    },
    async getLangs() {
      const { result, data } = await api.home.getLanguages()
      if (result && data) {
        this.lang = data.data
      }
    },
    async getI18n(code) {
      const { result, data } = await api.home.getI18nConfig(code)
      if (result && data) {
        if(Object.keys(data.data)
          .every(key => data.data[key])) {
            this.langMap.set(code, data.data)
          }
        else {
        }
      }
    },
    async login() {
      const { result, data } = await api.user.login(this.form)
      if (result && data.login) {
        window.location.href = !isPrdSite
          ?  `http://oms.aybases.com/proxylogin?token=${data.token}&lang=${this.currentLangs.code}`
          : `http://service.quartzx.com:9005/proxylogin?token=${data.token}&lang=${this.currentLangs.code}`
      }
      else {
        this.$message.error(data.msg || '用户名或者密码不正确 ')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  display: block;
  margin-top: -25px;
  margin-right: 10px;
}
.login-container {
  height: 100%;
  display: flex;
  align-items: flex-end;
}
.user-input, .password-input {
  margin-right: 8px;
}
/deep/.el-input--small .el-input__inner {
    border: 1px solid #b3b3b3;
    padding: 0 20px;
    font-size: 12px;
    line-height: 1;
    height: 32px;
    border-radius: 6px;
    width: 124px;
    box-sizing: content-box;
  }

.others {
  margin-left: 8px;
  height: 32px;
  line-height: 32px;
  color: #ccc
}
</style>
